const CommentList = () => import('./CommentList');
const CommentCard = () => import('./CommentCard');
const AddComment = () => import('./AddComment');
const AddReply = () => import('./AddReply');
const CommentSort = () => import('./CommentSort');
const CommentContainer = () => import('./CommentContainer');

export { CommentList, CommentCard, AddComment, AddReply, CommentSort, CommentContainer };
